import { IVersionRules } from './interfaces';

export const defaultVersionRules: IVersionRules = {
  optionAOnly: false,
};
